import React from "react";

/**
 * The component for rendering the Bootstrap modal footer.
 *
 * @param {object} props Initial props
 * @returns {object} The React element
 */
function ModalFooter(props) {
  return <div className="modal-footer">{props.children}</div>;
}

export default ModalFooter;
